import {
  LOCAL_SET_JOB_PHASES,
  LOCAL_ADD_JOB_PHASE,
  LOCAL_DELETE_JOB_PHASE,
  LOCAL_UPDATE_JOB_PHASE,
} from './mutationTypes';

export default {
  [LOCAL_SET_JOB_PHASES]: (state, phases) => {
    state.jobPhases = phases;
  },
  [LOCAL_ADD_JOB_PHASE]: (state, phase) => {
    state.jobPhases.push(phase);
  },
  [LOCAL_DELETE_JOB_PHASE]: (state, phaseId) => {
    state.jobPhases = state.jobPhases.filter((p) => p._id !== phaseId);
  },
  [LOCAL_UPDATE_JOB_PHASE]: (state, { phaseId, updates }) => {
    state.jobPhases = state.jobPhases.map((p) => {
      if (p._id === phaseId) return { ...p, ...updates };
      // if (updates.isDefault) return { ...p, isDefault: false };
      return p;
    });
  },
};
